// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/boards/style/index.less
// module id = 145
// module chunks = 0